// extracted by mini-css-extract-plugin
export default {"previewLink":"PreviewLink_previewLink__Qb0bj"};